import 'slick-carousel/slick/slick.min';
import 'jquery-match-height/jquery.matchHeight.js';
import {sticky_elements} from '../components/sticky';
import {flip_cards} from '../components/flipcards';
import {timeline} from '../components/timeline';
import {back_to_top} from '../components/back-to-top';
import {brands} from '../components/brands';
import 'jquery.easing';
import {ResizeSensor} from 'css-element-queries';


export default {
  init() {
    $('li.js-scroll-trigger, div').find('a[href*="#"]:not([href="#"])').click(function (e) {
      e.preventDefault();

      let offset = $('nav').outerHeight();

      if($('.is-sticky').length > 0){
        offset = offset + $('.is-sticky').outerHeight();
      }

      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        let target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate(
            {
              scrollTop: target.offset().top - offset,
            },
            1000,
            'easeInOutExpo'
          );
          return false;
        }
      }
    });

    // Closes responsive menu when a scroll trigger link is clicked
    $('.js-scroll-trigger').click(function () {
      $('.navbar-collapse').collapse('hide');
    });

    $('a[href$="#contactform"], .open-contact').click(function (e) {
      e.preventDefault();

      if(!$('#contactform').hasClass('active')) {
        $('#contactform').addClass('active');
      } else {
        $('#contactform').removeClass('active');
      }
    });

    /* SLICK */
    $('.slider-customer').slick({
      vertical: true,
      verticalSwiping: true,
    });

    $('.contact-button').click(function() {
      if($('#contactform').hasClass('active')) {
        $('#contactform').removeClass('active');
      } else {
        $('#contactform').addClass('active');
      }
    });

    $('.section-cards').each(function() {
      $(this).find('.white-card').matchHeight({
        byRow: false,
      });

      $('.white-card').on('change', function () {
        $('.color-pink').css('height',  $('.white-card').height() * 2 + 15);
      });
    });

    new ResizeSensor(jQuery('.white-card'), function() {
      if($(window).width() >= 576) {
        $('.color-pink').css('height',  $('.white-card').height() * 2 + 24);
      } else {
        $('.color-pink').css('height', 'auto');
      }
    });

    back_to_top();
    sticky_elements();
    flip_cards();
    brands();
  },
  finalize() {
    timeline();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js